// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InstrumentConfigurationFactory } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useRegistryInstrumentConfigurationFactory: () => UseQueryResult<
  TemplateContract<InstrumentConfigurationFactory>,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryRegistryInstrumentConfigurationFactory', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryRegistryInstrumentConfigurationFactory(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useRegistryInstrumentConfigurationFactory;
